import { useState, useEffect } from "react";
import "./Tooltip.css";
const Tooltip = ({ text, children, id }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const handleMouseEnter = (e) => {
      const target = e.target;
      const rect = target.getBoundingClientRect();

      setShowTooltip(true);
    };

    const handleMouseLeave = () => {
      setShowTooltip(false);
    };

    const target = document.getElementById(`tooltip-target-${id}`);
    if (target) {
      target.addEventListener("mouseenter", handleMouseEnter);
      target.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => {
      if (target) {
        target.removeEventListener("mouseenter", handleMouseEnter);
        target.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, []);

  return (
    <div className="custom-tooltip-container">
      {showTooltip && <div className="custom-tooltip">{text}</div>}
      <span id={`tooltip-target-${id}`}>{children}</span>
    </div>
  );
};

export default Tooltip;
